/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_hero_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool different.`)
};

const es_home_hero_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas diferentes.`)
};

const de_home_hero_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anders denken.`)
};

const nl_home_hero_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool anders.`)
};

const fr_home_hero_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pensez différemment.`)
};

const it_home_hero_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pensa diverso.`)
};

const pt_br2_home_hero_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pense diferente.`)
};

const pt_home_hero_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pense diferente.`)
};

const ja_home_hero_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`違う発想で。`)
};

const zh_home_hero_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不同凡想。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_hero_line1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_hero_line1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_hero_line1", locale)
	if (locale === "en") return en_home_hero_line1(inputs)
	if (locale === "es") return es_home_hero_line1(inputs)
	if (locale === "de") return de_home_hero_line1(inputs)
	if (locale === "nl") return nl_home_hero_line1(inputs)
	if (locale === "fr") return fr_home_hero_line1(inputs)
	if (locale === "it") return it_home_hero_line1(inputs)
	if (locale === "pt-BR") return pt_br2_home_hero_line1(inputs)
	if (locale === "pt") return pt_home_hero_line1(inputs)
	if (locale === "ja") return ja_home_hero_line1(inputs)
	return zh_home_hero_line1(inputs)
};